// project import
import Navigation from './Navigation';
import SimpleBar from '../../../../components/third-party/SimpleBar';

import { SelectOrganizationForm } from './SelectOrganizationForm/SelectOrganizationForm';
import { FC } from 'react';
import { Box } from '@mui/material';
import { useMenu } from '../../../../store/menu';
import { UpgradeBanner } from './UpgradeBanner';
// ==============================|| DRAWER CONTENT ||============================== //

const DrawerContent: FC = () => {
	const {
		state: { drawerOpen },
	} = useMenu();
	return (
		<Box sx={{ flex: 1 }}>
			<SimpleBar
				sx={{
					'& .simplebar-content': {
						display: 'flex',
						flexDirection: 'column',
					},
				}}
			>
				{drawerOpen === true && <SelectOrganizationForm />}
				<Navigation />
				<UpgradeBanner />
			</SimpleBar>
		</Box>
	);
};

export default DrawerContent;
